var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.RosterRecordTitle === null
    ? _c("noContent")
    : _c("ContentLayout", {
        attrs: {
          widthClass: " min-1200",
          backgroundClass: "transparent",
          pad: "0",
          title: _vm.RosterRecordTitle,
        },
        scopedSlots: _vm._u([
          {
            key: "nav-actions",
            fn: function () {
              return [
                _vm.RosterRecordData && _vm.RosterRecordData["flow_status"] == 1
                  ? _c("approvalTools", {
                      attrs: {
                        curUuid: _vm.RosterRecordData["uuid"],
                        staff_uuid: _vm.curStaff,
                        flag: _vm.RosterRecordData["cancel_flag"],
                        data_type: _vm.RosterRecordData["data_type"],
                        final_node: Number(
                          _vm.RosterRecordData["is_final_task_node"]
                        ),
                        matched: Number(_vm.RosterRecordData["is_match"])
                          ? true
                          : false,
                        canRevoke: Number(
                          _vm.RosterRecordData["is_allow_revoke"]
                        ),
                        canRollback: Number(
                          _vm.RosterRecordData["is_allow_rollback"]
                        ),
                        canForward: Number(
                          _vm.RosterRecordData["is_allow_forward"]
                        ),
                      },
                      on: {
                        back: _vm.onBack,
                        forward: _vm.onForward,
                        approval: _vm.onApproval,
                        reject: _vm.onReject,
                      },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "page-main",
            fn: function () {
              return [
                _vm.RosterRecordData
                  ? _c("ApprovalTriger", {
                      attrs: {
                        "bg-color": _vm.RosterRecordData.approval_bg_color,
                        "slide-color": _vm.RosterRecordData.approval_tint_color,
                      },
                      on: {
                        triger: function ($event) {
                          return _vm.$toPage(
                            "/admin/approval-process/roster-detail/" +
                              _vm.$route.params.params +
                              "/approval-detail/" +
                              _vm.$route.params.params
                          )
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "time",
                            fn: function () {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$getDateTime(
                                        _vm.RosterRecordData
                                          .operate_utc_datetime,
                                        "YYYY/MM/DD HH:mm"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "status",
                            fn: function () {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$getCommonLangValue(
                                        _vm.RosterRecordData.status_detail
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        10382332
                      ),
                    })
                  : _vm._e(),
                _c("Taber", {
                  attrs: {
                    curTab: _vm.curTab,
                    items: _vm.taber,
                    special: "",
                    contentBackground: "mrc-grey pa-0",
                  },
                  on: {
                    change: function (tab) {
                      return (_vm.curTab = tab)
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "content-1",
                      fn: function () {
                        return [
                          _c(
                            "v-container",
                            {
                              staticClass: "rounded-lg pa-0",
                              attrs: { fluid: "" },
                            },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "rounded-lg",
                                  class: _vm.iSEdited ? "pa-1" : "pa-1",
                                  attrs: { elevation: 0 },
                                },
                                [
                                  _c(
                                    "v-card-text",
                                    {
                                      staticClass:
                                        "rounded-lg transparent pa-0",
                                    },
                                    [
                                      _c(
                                        "v-form",
                                        {
                                          ref: "form",
                                          staticClass:
                                            "transparent pa-3 fill-height scroll_content",
                                          class: _vm.iSEdited
                                            ? "rounded-lg"
                                            : "rounded-lg",
                                          attrs: { "lazy-validation": "" },
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    xs: "12",
                                                    sm: "12",
                                                    md: "12",
                                                    lg: "12",
                                                    cols: "12",
                                                  },
                                                },
                                                [
                                                  _c("normalInputTextFiled", {
                                                    attrs: {
                                                      readonly: true,
                                                      filled: false,
                                                      label: _vm.$t(
                                                        "label_essweb_RosterFormRecord_form_rosterNameLabel"
                                                      ),
                                                      rules: _vm.$GetRules(
                                                        ["_Require_Rules"],
                                                        [null]
                                                      ),
                                                      dense: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.RosterRecordData
                                                          .roster_form_record_title,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.RosterRecordData,
                                                          "roster_form_record_title",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "RosterRecordData.roster_form_record_title",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    xs: "12",
                                                    sm: "6",
                                                    md: "6",
                                                    lg: "6",
                                                    cols: "12",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-sheet",
                                                    {
                                                      staticClass:
                                                        "text--secondary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "label_essweb_RosterFormRecord_form_startDateLabel"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      readonly: true,
                                                      filled: false,
                                                      dense: "",
                                                      "single-line": "",
                                                      label: _vm.$t(
                                                        "label_essweb_RosterFormRecord_form_startDateLabel"
                                                      ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.RosterRecordData
                                                          .roster_utc_start_date,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.RosterRecordData,
                                                          "roster_utc_start_date",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "RosterRecordData.roster_utc_start_date",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    xs: "12",
                                                    sm: "6",
                                                    md: "6",
                                                    lg: "6",
                                                    cols: "12",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-sheet",
                                                    {
                                                      staticClass:
                                                        "text--secondary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "label_essweb_RosterFormRecord_form_endDateLabel"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      readonly: true,
                                                      filled: false,
                                                      dense: "",
                                                      "single-line": "",
                                                      label: _vm.$t(
                                                        "label_essweb_RosterFormRecord_form_endDateLabel"
                                                      ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.RosterRecordData
                                                          .roster_utc_end_date,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.RosterRecordData,
                                                          "roster_utc_end_date",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "RosterRecordData.roster_utc_end_date",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    xs: "12",
                                                    sm: "12",
                                                    md: "12",
                                                    lg: "12",
                                                    cols: "12",
                                                  },
                                                },
                                                [
                                                  _c("normalInputTextFiled", {
                                                    attrs: {
                                                      readonly: true,
                                                      filled: false,
                                                      label: _vm.$t(
                                                        "label_essweb_RosterFormRecord_form_descriptionLabel"
                                                      ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.RosterRecordData
                                                          .roster_form_record_description,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.RosterRecordData,
                                                          "roster_form_record_description",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "\n                        RosterRecordData.roster_form_record_description\n                      ",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    xs: "12",
                                                    sm: "12",
                                                    md: "12",
                                                    lg: "12",
                                                    cols: "12",
                                                  },
                                                },
                                                [
                                                  _c("normalInputTextFiled", {
                                                    attrs: {
                                                      readonly: true,
                                                      filled: false,
                                                      label: _vm.$t(
                                                        "label_essweb_RosterFormRecord_form_remarkLabel"
                                                      ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.RosterRecordData
                                                          .remarks,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.RosterRecordData,
                                                          "remarks",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "RosterRecordData.remarks",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-card",
                                {
                                  staticClass: "rounded-lg mt-4 pa-0",
                                  attrs: { elevation: 0 },
                                },
                                [
                                  _c(
                                    "v-card-text",
                                    {
                                      staticClass:
                                        "rounded-lg transparent pa-1",
                                    },
                                    [
                                      _c(
                                        "v-form",
                                        {
                                          ref: "form2",
                                          staticClass:
                                            "white pa-3 fill-height scroll_content",
                                          class: _vm.iSEdited
                                            ? "rounded-lg"
                                            : "rounded-lg",
                                          attrs: { "lazy-validation": "" },
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    xs: "12",
                                                    sm: "6",
                                                    md: "6",
                                                    lg: "6",
                                                    cols: "12",
                                                  },
                                                },
                                                [
                                                  _c("normalInputTextFiled", {
                                                    attrs: {
                                                      readonly: true,
                                                      filled: false,
                                                      label: _vm.$t(
                                                        "label_essweb_RosterFormRecord_form_swiftNumberLabel"
                                                      ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.RosterRecordData
                                                          .roster_form_record_swift_number,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.RosterRecordData,
                                                          "roster_form_record_swift_number",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "\n                        RosterRecordData.roster_form_record_swift_number\n                      ",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    xs: "12",
                                                    sm: "6",
                                                    md: "6",
                                                    lg: "6",
                                                    cols: "12",
                                                  },
                                                },
                                                [
                                                  _c("normalInputTextFiled", {
                                                    attrs: {
                                                      readonly: true,
                                                      filled: false,
                                                      label: _vm.$t(
                                                        "label_essweb_RosterFormRecord_form_remarkLabel"
                                                      ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.RosterRecordData
                                                          .remarks,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.RosterRecordData,
                                                          "remarks",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "RosterRecordData.remarks",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-card",
                                {
                                  staticClass: "rounded-lg mt-4",
                                  attrs: { "rounded-lg": "", elevation: "0" },
                                },
                                [
                                  _c(
                                    "v-card-text",
                                    { staticClass: "rounded-lg" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "title pa-2 black--text",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "label_essweb_RosterFormRecord_form_table_avaliblehiftTitle"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-row",
                                        _vm._l(
                                          _vm.ShiftList,
                                          function (item, index) {
                                            return _c(
                                              "v-col",
                                              {
                                                key: "shift--" + index,
                                                attrs: {
                                                  xs: "12",
                                                  sm: "6",
                                                  md: "6",
                                                  lg: "6",
                                                  cols: "12",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    attrs: {
                                                      "two-line": "",
                                                      dense: "",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-avatar",
                                                      {
                                                        staticClass:
                                                          "mr-2 round-lg",
                                                        attrs: {
                                                          color:
                                                            item.color_code,
                                                          rounded: "",
                                                          size: "48",
                                                          width: 3 * 48,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-truncate black--text pa-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.shift_abbr
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-list-item-content",
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "d-flex align-center",
                                                          },
                                                          [
                                                            _c("svg-icon", {
                                                              attrs: {
                                                                size: "20",
                                                                fill: item.color_code,
                                                                iconClass:
                                                                  "LabeledColour",
                                                              },
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "black--text pl-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.shift_abbr
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-list-item-subtitle",
                                                          {
                                                            staticClass:
                                                              "pl-6 text--secondary",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$timeMachine(
                                                                    item.start_utc_time
                                                                  ) +
                                                                    " - " +
                                                                    _vm.$timeMachine(
                                                                      item.end_utc_time
                                                                    )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "content-2",
                      fn: function () {
                        return [
                          _c(
                            "v-card",
                            {
                              staticClass:
                                "fill-height max-width pa-0 elevation-0",
                            },
                            [
                              _c(
                                "v-card-text",
                                {
                                  staticClass:
                                    "fill-height max-width pa-2 pt-3",
                                },
                                [
                                  _c("RosterPlan", {
                                    attrs: {
                                      Roster_uuid: _vm.Roster_uuid,
                                      change: _vm.isChange,
                                      iSEdited: _vm.iSEdited,
                                      shiftList: _vm.ShiftList,
                                      startTime:
                                        _vm.RosterRecordData
                                          .roster_utc_start_date,
                                      endTime:
                                        _vm.RosterRecordData
                                          .roster_utc_end_date,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "content-3",
                      fn: function () {
                        return [
                          _c(
                            "v-card",
                            {
                              staticClass:
                                "fill-height max-width pa-0 elevation-0",
                            },
                            [
                              _c(
                                "v-card-text",
                                {
                                  staticClass:
                                    "fill-height max-width pa-2 pt-3",
                                },
                                [
                                  _c("RosterPlanB", {
                                    attrs: {
                                      Roster_uuid: _vm.Roster_uuid,
                                      change: _vm.isChange,
                                      iSEdited: _vm.iSEdited,
                                      shiftList: _vm.ShiftList,
                                      startTime:
                                        _vm.RosterRecordData
                                          .roster_utc_start_date,
                                      endTime:
                                        _vm.RosterRecordData
                                          .roster_utc_end_date,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "tools-main",
            fn: function () {
              return [
                _c("normalDialog", {
                  attrs: {
                    deleteModel: "",
                    dialog: _vm.showDelete,
                    title: _vm.deleteTitle,
                  },
                  on: {
                    close: function ($event) {
                      _vm.showDelete = false
                    },
                    confirm: _vm.toDelete,
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }